"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendAPIUpload = exports.sendAPIRequest = void 0;
const axios_1 = __importDefault(require("axios"));
const axios_retry_1 = __importDefault(require("axios-retry"));
const client = axios_1.default.create();
(0, axios_retry_1.default)(client, { retries: 0 });
const sendAPIRequest = (url, method = "GET", data, params, retries) => new Promise((resolve, reject) => {
    const configObj = {
        url,
        method,
        withCredentials: true,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
    };
    const tokenElement = document.getElementsByName("csrf-token")[0];
    if (tokenElement) {
        configObj.headers["X-CSRF-Token"] = tokenElement.getAttribute("content");
    }
    if (data !== undefined) {
        configObj.data = data;
    }
    if (params !== undefined) {
        configObj.params = params;
    }
    if (retries !== undefined) {
        configObj["axios-retry"] = {
            retries,
        };
    }
    client(url, configObj)
        .catch((error) => {
        var _a, _b;
        const redirect_path = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.redirect_path;
        if (redirect_path) {
            window.location.href = redirect_path;
            return;
        }
        return reject(error);
    })
        .then((result) => resolve(result));
});
exports.sendAPIRequest = sendAPIRequest;
const sendAPIUpload = (url, method = "GET", file, params) => new Promise((resolve, reject) => {
    const configObj = {
        url,
        method: method,
        withCredentials: true,
        headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "X-Requested-With": "XMLHttpRequest",
        },
    };
    const tokenElement = document.getElementsByName("csrf-token")[0];
    if (tokenElement) {
        configObj.headers["X-CSRF-Token"] = tokenElement.getAttribute("content");
    }
    const formData = new FormData();
    formData.append("file", file);
    configObj.data = formData;
    if (params !== undefined) {
        configObj.params = params;
    }
    (0, axios_1.default)(url, configObj)
        .catch((error) => {
        var _a, _b;
        const redirect_path = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.redirect_path;
        if (redirect_path) {
            window.location.href = redirect_path;
            return;
        }
        return reject(error);
    })
        .then((result) => resolve(result));
});
exports.sendAPIUpload = sendAPIUpload;
